import ReactDOM from 'react-dom';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import App from './App';

ReactDOM.render(  
  <App />,
  document.getElementById('root')
);

